/**
 * General city-centre coordinates for the Locations block map.
 * These are intentionally approximate - we don't expose exact office/data centre addresses.
 *
 * To add a new city: add an entry here with the display name as key (e.g., "London", "New York").
 * The CMS select dropdown options are generated automatically from these keys.
 */
export const cityCoordinates: Record<string, { latitude: number; longitude: number }> = {
  London: { latitude: 51.51, longitude: -0.12 },
  Bengaluru: { latitude: 12.97, longitude: 77.59 },
  Austin: { latitude: 30.27, longitude: -97.74 },
  Hamburg: { latitude: 53.55, longitude: 9.99 },
  Frankfurt: { latitude: 50.11, longitude: 8.68 },
  Mumbai: { latitude: 19.08, longitude: 72.88 },
  'New York': { latitude: 40.71, longitude: -74.01 },
  Phoenix: { latitude: 33.45, longitude: -112.07 },
  Florida: { latitude: 27.99, longitude: -81.76 },
  Jakarta: { latitude: -6.21, longitude: 106.85 },
}
